import styled from 'styled-components'

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 10px;

  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
  padding: 8px 20px;
`
